<template>
  <div class="product-info-wrapper">
    <div class="banner">
      <div class="cover cover-jczlpt">
        <div class="cover-text">
          <h4>社会基层治理平台</h4>
          <p class="info">社会基层治理平台是以社区场景为载体的网格化管理平台。聚焦基层工作人员日常工作的痛点和难点，基于事件驱动、业务流转、多级联动的需求，结合大数据、物联网、云计算等技术，高效解决基层日常管理问题。辅助基层政府部门进行工作模式升级，切实提升基层治理水平，维护社会稳定。</p>
        </div>
      </div>
    </div>
    <!-- 产品功能 -->
    <div class="product-function">
      <div class="common-title">
        <div class="common-title-content">
          产品功能
        </div>
      </div>
      <div class="product-function-list">
        <div class="item" v-for="(item, index) in funcList" :key="index">
          <img :src="item.imgUrl" />
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
    <!-- 产品优势 -->
    <div class="product-advantage product-advantage-blue bg2F61AE">
      <div class="common-title">
        <div class="common-title-content">
          产品优势
        </div>
      </div>
      <div class="content content-blue">
        <div class="circle">
          <div class="badge">
            <img src="@/assets/images/productInfo/jczlpt/badge.png" />
          </div>
          <div class="feature feature-one">
            <div class="text">基层多级业务联动</div>
          </div>
          <div class="feature feature-two">
            <div class="text">一屏全局综合指挥</div>
          </div>
          <div class="feature feature-three">
            <div class="text">事件流程监督考核</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 应用场景 -->
    <div class="product-application-scene">
      <div class="common-title">
        <div class="common-title-content">
          应用场景
        </div>
      </div>
      <div class="product-scene-list">
        <div class="item" v-for="(item, index) in sceneList" :key="index">
          <img :src="item.imgUrl" />
          <div class="text" v-html="item.text"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "jczlpt",
  data() {
    return {

      funcList: [
        {
          imgUrl: require("@/assets/images/productInfo/jczlpt/ico_sjgl.png"),
          text: "事件管理"
        },
        {
          imgUrl: require("@/assets/images/productInfo/jczlpt/ico_mdtj.png"),
          text: "矛盾调解"
        },
        {
          imgUrl: require("@/assets/images/productInfo/jczlpt/ico_rwfp.png"),
          text: "任务分派"
        },
        {
          imgUrl: require("@/assets/images/productInfo/jczlpt/ico_zzyw.png"),
          text: "综治业务"
        },
        {
          imgUrl: require("@/assets/images/productInfo/jczlpt/ico_qfqz.png"),
          text: "群防群治"
        }
      ],
      sceneList: [
        {
          imgUrl: require("@/assets/images/productInfo/jczlpt/jzzh.png"),
          text: "街镇指挥"
        },
        {
          imgUrl: require("@/assets/images/productInfo/jczlpt/rkgl.png"),
          text: "人口管理"
        },
        {
          imgUrl: require("@/assets/images/productInfo/jczlpt/zagl.png"),
          text: "治安管理"
        },
        {
          imgUrl: require("@/assets/images/productInfo/jczlpt/wggl.png"),
          text: "网格管理"
        }
      ]
    };
  }
};
</script>
